'use client';

import type {As} from '@chakra-ui/react';
import {Button, Stack, StackItem} from '@chakra-ui/react';
import type {ComponentWithAs} from '@chakra-ui/system';
import {forwardRef} from '@chakra-ui/system';

import type {WidgetContext} from './Container';
import {useStyles} from './context';
import {parts} from './theme';

type Props = WidgetContext;

export const WidgetFooter: ComponentWithAs<As, Props> = forwardRef(
  (
    {children, isInteractive: _isInteractive, isEmpty: _isEmpty, isLoading: _isLoading, hasError: _hasError, ...props},
    ref,
  ) => {
    const {footer: style} = useStyles();
    return (
      <StackItem sx={{...style, ...props.sx}} {...props} ref={ref} {...parts.footer.attrs}>
        {children ? (
          children
        ) : (
          <Stack justify={`space-between`} direction={{base: `column`, md: `row`}} spacing={`5`} width={`full`}>
            <Stack spacing={`3`} ml={`auto`} direction={`row`} align={`end`}>
              <Button variant={`plain`}>Download</Button>
              <Button variant={`tinted`}>View</Button>
            </Stack>
          </Stack>
        )}
      </StackItem>
    );
  },
);

export type {Props as WidgetFooterProps};
